import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/common/LoadingFallback/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/containers/OfferListContainer/index.tsx");
